import React, { Fragment } from 'react';
import { Container, Button } from 'react-bootstrap';
import Header from '../../../components/header';
import Head from '../../../components/head';
import Footer from '../../../components/footer';
import ListAtaCons from '../../../components/saude/documentos/atasconselho';


function ListAtaConsScreen() {
    return (
        <Fragment>
            <Head titulo="Atas de reuniões do Conselho Municipal de Saúde em Macuco" />
            <Header />
            <Container>
               <ListAtaCons /><br/><br/>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListAtaConsScreen;